import { FormGroup, InputLabel } from "@mui/material";
import ErrorMessageTypo from "./ErrorMessageTypo";
import { MuiColorInput } from "mui-color-input";
import Label from "./Label";

export const BasicFormikColorField = ({
  fieldId,
  field,
  formik,
  labelAlignement = null,
}) => {
  const label = field.spec.label.split("_")[0];
  const placeholder = field.spec.label.split("_")[1];
  field.spec.label = label;
  const key = fieldId;

  return (
    <>
      {labelAlignement && <Label label={label} />}
      <FormGroup
        key={key}
        sx={{
          marginTop: 1,
        }}
      >
        {!labelAlignement && <InputLabel htmlFor={key}>{label}</InputLabel>}
        <MuiColorInput
          type="text"
          name={key}
          id={key}
          size="small"
          placeholder={placeholder}
          format="hex"
          value={formik.values[key]}
          onChange={(color) => {
            formik.setFieldValue(key, color);
          }}
          error={formik.errors[key] ? true : false}
        />
        {formik.errors[key] ? (
          <ErrorMessageTypo error={formik.errors[key]} />
        ) : null}
      </FormGroup>
    </>
  );
};
